import { SearchType } from 'src/app/shared/components/listing-page/services/listing-page-model/listing-page-model.types';
import { TranslateRegistry } from 'src/app/services/translate/translate.registry';
import { SEARCH_HINTS } from 'src/app/shared/components/listing-page/services/listing-page-model/listing-page-model.constants';
import { TwoWayRequestProcessingFieldName } from '../services/request-processing.types';

export const REQUEST_PROCESSING_SEARCH_TYPES: SearchType[] = [
  {
    text: TranslateRegistry.get.SEARCH.TYPE.ALL,
    value: 1,
    types: [
      TwoWayRequestProcessingFieldName.CommDeviceId,
      TwoWayRequestProcessingFieldName.SerialNumber,
      TwoWayRequestProcessingFieldName.CommandGroupName,
      TwoWayRequestProcessingFieldName.ImageName,
      TwoWayRequestProcessingFieldName.User
    ],
    hintText: SEARCH_HINTS.CommDeviceIdOrSerialNumberOrCommandGroupNameOrImageNameOrUser
  },
  {
    text: TranslateRegistry.get.SEARCH.TYPE.COMM_DEVICE_ID,
    value: 2,
    types: [TwoWayRequestProcessingFieldName.CommDeviceId],
    hintText: SEARCH_HINTS.CommDeviceId
  },
  {
    text: TranslateRegistry.get.SEARCH.TYPE.SERIAL_NUMBER,
    value: 3,
    types: [TwoWayRequestProcessingFieldName.SerialNumber],
    hintText: SEARCH_HINTS.SerialNumber
  },
  {
    text: TranslateRegistry.get.SEARCH.TYPE.COMMAND_GROUP_NAME,
    value: 4,
    types: [TwoWayRequestProcessingFieldName.CommandGroupName],
    hintText: SEARCH_HINTS.CommandGroupName
  },
  {
    text: TranslateRegistry.get.SEARCH.TYPE.IMAGE_NAME,
    value: 5,
    types: [TwoWayRequestProcessingFieldName.ImageName],
    hintText: SEARCH_HINTS.ImageName
  },
  {
    text: TranslateRegistry.get.SEARCH.TYPE.USER_NAME,
    value: 6,
    types: [TwoWayRequestProcessingFieldName.User],
    hintText: SEARCH_HINTS.UserName
  }
];

export const REQUEST_PROCESSING_DEFAULT_SEARCH_TYPE: SearchType = REQUEST_PROCESSING_SEARCH_TYPES[0];
